import { StarOutline } from '@crehana/icons';
import {
  Chat,
  PersonDone,
  Leader,
  Report,
  Results,
  Departments,
  Okrs,
  Awards,
  SkillXp,
  Activity2,
  Megaphone,
  Play,
  PlaySquare,
  Video,
} from '@crehana/icons/outline';
import { GraduateHat } from '@crehana/icons/pictograms';

import { ProductTabType } from './types';

export const PRODUCT_TABS: ProductTabType[] = [
  {
    title: 'PRODUCT_TAB1_TITLE',
    description: 'PRODUCT_TAB1_DESCRIPTION',
    image: {
      es: 'https://crehana-vercel-images-prd.imgix.net/public/1c5e72d7-9cee-429a-bfce-074e34f462ca-upskilling.png?auto=format&fit=clip',
      pt: 'https://crehana-vercel-images-prd.imgix.net/public/b45621ea-74aa-45fc-882a-11a075d56f44-upskilling-br.png?auto=format&fit=clip',
    },
    cards: [
      {
        icon: Play,
        description: 'PRODUCT_TAB1_CARD1',
      },
      {
        icon: GraduateHat,
        description: 'PRODUCT_TAB1_CARD2',
      },
      {
        icon: Megaphone,
        description: 'PRODUCT_TAB1_CARD3',
      },
      {
        icon: Chat,
        description: 'PRODUCT_TAB1_CARD4',
      },
      {
        icon: PersonDone,
        description: 'PRODUCT_TAB1_CARD5',
      },
    ],
  },
  {
    title: 'PRODUCT_TAB2_TITLE',
    description: 'PRODUCT_TAB2_DESCRIPTION',
    image: {
      es: 'https://crehana-vercel-images-prd.imgix.net/public/0a71674c-ca98-442a-a5fc-27d0ed5bedba-gestion-aprendizaje.png?auto=format&fit=clip',
      pt: 'https://crehana-vercel-images-prd.imgix.net/public/9bcdd8ee-a612-485c-a884-d9b0aee03d12-gestion-aprendizaje-br.png?auto=format&fit=clip',
    },
    cards: [
      {
        icon: PlaySquare,
        description: 'PRODUCT_TAB2_CARD1',
      },
      {
        icon: Video,
        description: 'PRODUCT_TAB2_CARD2',
      },
      {
        icon: Activity2,
        description: 'PRODUCT_TAB2_CARD3',
      },
      {
        icon: Departments,
        description: 'PRODUCT_TAB2_CARD4',
      },
    ],
  },
  {
    title: 'PRODUCT_TAB3_TITLE',
    description: 'PRODUCT_TAB3_DESCRIPTION',
    image: {
      es: 'https://crehana-vercel-images-prd.imgix.net/public/3abae78a-45f4-4827-a29d-017de29be55e-gestion-talento.png?auto=format&fit=clip',
      pt: 'https://crehana-vercel-images-prd.imgix.net/public/9dc0f6e5-0890-4413-bde1-84822fcddb38-gestion-talento-br.png?auto=format&fit=clip',
    },
    cards: [
      {
        icon: Okrs,
        description: 'PRODUCT_TAB3_CARD1',
      },
      {
        icon: Awards,
        description: 'PRODUCT_TAB3_CARD2',
      },
      {
        icon: StarOutline,
        description: 'PRODUCT_TAB3_CARD3',
      },
    ],
  },
  {
    title: 'PRODUCT_TAB4_TITLE',
    description: 'PRODUCT_TAB4_DESCRIPTION',
    image: {
      es: 'https://crehana-vercel-images-prd.imgix.net/public/e96210da-a606-41b4-9bf7-b00e6f603a8e-data-reportes.png?auto=format&fit=clip',
      pt: 'https://crehana-vercel-images-prd.imgix.net/public/d3310e98-c33a-4d86-8650-44b56937f1b4-data-reportes-br.png?auto=format&fit=clip',
    },
    cards: [
      {
        icon: SkillXp,
        description: 'PRODUCT_TAB4_CARD1',
      },
      {
        icon: Results,
        description: 'PRODUCT_TAB4_CARD2',
      },
      {
        icon: Report,
        description: 'PRODUCT_TAB4_CARD3',
      },
      {
        icon: Leader,
        description: 'PRODUCT_TAB4_CARD4',
      },
    ],
  },
];
